import React from "react";
import "../pages/style/blog.css";
import Object_blog from "../assets/header_bg/Objet_header_blog.png";

import SideList from "./../home/SideList";
import Popup from "reactjs-popup";
import BurgerIcon from "../home/BurgerIcon";
import Menu from "../home/Menu";
import MapAddresse from "../home/mapAdresse";
import NewsLetter from "../home/newsLetter";
import Footer from "../home/footer";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import image_A1 from "../assets/blog_images/image_A1.png";
import image_A2 from "../assets/blog_images/image_A2.png";
import image_A3 from "../assets/blog_images/image_A3.png";
import image_A4 from "../assets/blog_images/image_A4.png";
import image_A5 from "../assets/blog_images/image_A5.png";
import image_A6 from "../assets/blog_images/image_A6.png";
import image_A7 from "../assets/blog_images/image_A7.png";
import image_A8 from "../assets/blog_images/image_A8.png";
import image_A9 from "../assets/blog_images/image_A9.png";
import image_A10 from "../assets/blog_images/image_A10.jpg";
import image_A11 from "../assets/blog_images/image_A11.jpg";
import arrow from "../assets/blog_images/arrow.svg";
// import arrowright from "../assets/blog_images/arrow-right.svg";
// import arrowleft from "../assets/blog_images/arrow-left.svg";
import ReactSVG from "react-svg";

import Slider from "react-slick";
import SliderBlog from "../pages/responsive/sliderBlog";
import axios from "axios";
import { Helmet } from "react-helmet";
import TagManager from 'react-gtm-module'


const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// const tagManagerArgs = {
//   dataLayer: {
//       userProject: 'Chifco_website',
//       page: 'blog'
//   },
//   dataLayerName: 'PageDataLayer'
// }

const Blog = (props) => (
  <div>
    <div className="containerImg">
      <div className="imagewithtext">
        <img
          style={{ paddingRight: "5px" }}
          src={
            `${process.env.REACT_APP_SERVER}` +
            "/images/" +
            props.blog.ImageBlog
          }
          alt=""
          className="image"
        />
        <div className="bottom-left">
          <div className="newbadge" style={{ background: "#1a54e7" }}>
            <p className="badgeTextStyle">Smart Things</p>
          </div>
        </div>
        <div className="overlay">
          <div className="text">
            <p
              className="pText"
              dangerouslySetInnerHTML={{ __html: props.blog.Description }}
            ></p>
            {/* <ReactSVG id="arrowposition" src={arrow} /> */}
          </div>
        </div>
      </div>
      <p className="titleArticleSuiv"> {props.blog.Title}</p>
      <p className="dateArticle">
        {(props.date.getDay().toString().length > 1
          ? props.date.getDay()
          : "0" + props.date.getDay()) +
          " " +
          monthNames[props.date.getMonth()] +
          " " +
          props.date.getFullYear()}
      </p>
    </div>
  </div>
);

const contentStyle = {
  position: "relative",
  background: "linear-gradient(to right, #0c0abe , #07054c)",
  border: "none",
  width: "100%",
  textAlign: "center",
  padding: "0px !important",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "80px",
  paddingBottom: "100%",
};

const styles = (theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

class Blogs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlide2: 1,
      blocs: [],
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }

  previous() {
    this.slider.slickPrev();
  }
  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    axios
      .get(`${process.env.REACT_APP_SERVER}` + "/blocs")
      .then((response) => {
        this.setState({ blocs: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  blogsList() {
    return this.state.blocs.map((currentblog) => {
      var blog_date = new Date(currentblog.date);
      return <Blog blog={currentblog} key={currentblog._id} date={blog_date} />;
    });
  }
  render() {
    const settings1 = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: false,
      className: "widthslid",
      afterChange: (current) => {
        this.setState({ activeSlide2: current });
      },
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    //TagManager.dataLayer(tagManagerArgs)
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Blog</title>
          <link
            rel="canonical"
            href={
              //"https://chifcositev2.chifco.com" +
              process.env.REACT_APP_CLIENT + 
              "/blog"
            }
          />
        </Helmet>
        <div className="banniereSlidBlog">
          {/*Menu horizontal Web*/}
          <div className="menu-horizontal">
            <Menu />
          </div>
          {/*Menu Responsive Popup*/}
          <div className="menuMobile">
            <Popup
              modal
              overlayStyle={{
                background: "linear-gradient(to right, #0c0abe , #07054c)",
                width: "100%",
              }}
              contentStyle={contentStyle}
              closeOnDocumentClick={false}
              trigger={(open) => <BurgerIcon open={open} />}
            >
              <SideList />
            </Popup>
          </div>

          <div className="flex-container-blog">
            <div className="titleSlideBlog">
              <h1 className="SousTitleSlideBlog">
                Toute l'actualité <br />
                de <b className="ChifcoBlogStyle">chifco</b>
              </h1>
            </div>

            <div className="imgBlogbg">
              <img className="imgObjectBlog" src={Object_blog} alt="" />
            </div>
          </div>
        </div>

        <div className="containerBlog">
          <div id="divTwoImg">
            <div className="imagewithtext">
              <img id="imageA1" src={image_A1} alt="" className="image" />
              <div className="bottom-left">
                <div className="newbadge" style={{ background: "#a9ce4e" }}>
                  <p className="badgeTextStyle">Entreprise</p>
                </div>
              </div>
              <div className="overlay">
                <div className="text">
                  <p className="pText">
                    Ingénieurs, consultants, marketeurs … Voici les jeunes
                    talents qui composent l’équipe Chifco. Ils sont plus de 20
                    au total, partageant des valeurs communes, et visant à aller
                    le plus loin possible. Malgré son jeune âge, la Team Chifco
                    est toujours prête à relever des défis...
                  </p>
                  {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                </div>
              </div>
            </div>

            <div className="imagewithtext">
              <img id="imageA2" src={image_A2} alt="" className="image" />
              <div className="bottom-left">
                <div className="newbadge" id="imgA2">
                  <p className="badgeTextStyle">Entreprise</p>
                </div>
              </div>
              <div className="overlay">
                <div className="text">
                  <p className="pText">
                    2018 has been a challenging journey, full of inspiring
                    achievements and moments of genuine hope for all of us. We
                    had enjoyable moments and hard ones. But in the end, we
                    rised and made it through 2018. One more year of arduous
                    missions and successful projects...
                  </p>
                  {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                </div>
              </div>
            </div>
          </div>

          <div className="imagewithtext">
            <img
              style={{ width: "100%" }}
              src={image_A3}
              alt=""
              className="image1"
            />
            <div className="bottom-left">
              <div className="newbadge" style={{ background: "#a9ce4e" }}>
                <p className="badgeTextStyle">Entreprise</p>
              </div>
            </div>

            <div className="bottom-right">
              <p style={{ color: "white" }}>15 Décembere,2018</p>
            </div>
            <div className="centered">
              <h2>Birth of the Company</h2>
              <p id="paragBurth">
                Chifco is a Tunisian tech company specialized in the Internet of
                Things, Machine Learning and data processing.
              </p>
            </div>
            <div className="overlay">
              <div className="text">
                Chifco is a Tunisian tech company specialized in the Internet of
                Things, Machine Learning and data processing. It was founded by
                Amine Chouaieb in 2011, who at the time dreamed of changing the
                world by creating a startup like the Sillicon Valley ones.
                Therefore, he developed his very first prototype in 2011, while
                studying in France. He was 25 at that time.
                {/* <ReactSVG id="arrowposition2" src={arrow} /> */}
              </div>
            </div>
          </div>

          <div className="container-Smart-Projects">
            {/* { this.blogsList()} */}
            <div className="containerImg">
              <div className="imagewithtext">
                <img
                  style={{ paddingRight: "5px" }}
                  src={image_A4}
                  alt=""
                  className="image"
                />
                <div className="bottom-left">
                  <div className="newbadge" style={{ background: "#1a54e7" }}>
                    <p className="badgeTextStyle">Smart Things</p>
                  </div>
                </div>
                <div className="overlay">
                  <div className="text">
                    <p className="pText">
                      Data has value. Combined data has more value. Using that
                      great amount of data to get “things” interconnected is far
                      greater...
                    </p>
                    {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                  </div>
                </div>
              </div>
              <p className="titleArticleSuiv">
                Why do you need internet of things IoT?
              </p>
              <p className="dateArticle">01 october,2018</p>
            </div>
            <div className="containerImg">
              <div className="imagewithtext">
                <img
                  style={{ paddingLeft: "5px", paddingRight: "5px" }}
                  src={image_A5}
                  alt=""
                  className="image"
                />
                <div className="bottom-left">
                  <div
                    className="newbadge"
                    style={{ background: "#a9ce4e", marginLeft: "5px" }}
                  >
                    <p className="badgeTextStyle">Entreprise</p>
                  </div>
                </div>
                <div className="overlay">
                  <div className="text">
                    <p className="pText">
                      The term « Artificial Intelligence » or « AI » has lately
                      been mentioned more often than you might think, following
                      the launch of research centers specialized in AI...
                    </p>
                    {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                  </div>
                </div>
              </div>
              <p className="titleArticleSuiv">
                Artificial Intelligence: What about Chifco?
              </p>
              <p className="dateArticle">26 Septembre, 2018</p>
            </div>
            <div className="containerImg">
              <div className="imagewithtext">
                <img
                  style={{ paddingLeft: "5px" }}
                  src={image_A10}
                  alt=""
                  className="image"
                />
                <div className="bottom-left">
                  <div
                    className="newbadge"
                    style={{ background: "#1a54e7", marginLeft: "5px" }}
                  >
                    <p className="badgeTextStyle">Smart Things</p>
                  </div>
                </div>
                <div className="overlay">
                  <div className="text">
                    <p className="pText">
                      {" "}
                      Have you noticed lately, that there has been a sudden
                      trend of startups all around? No doubt, there are plenty
                      of passionate, smart, innovative entrepreneurs ...
                    </p>
                    {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                  </div>
                </div>
              </div>
              <p className="titleArticleSuiv">
                4 advices to build a successful IoT Startup
              </p>
              <p className="dateArticle">2 Mai, 2018</p>
            </div>
            <div className="containerImg">
              <div className="imagewithtext">
                <img
                  style={{ paddingRight: "5px" }}
                  src={image_A6}
                  alt=""
                  className="image"
                />
                <div className="bottom-left">
                  <div className="newbadge" style={{ background: "#1a54e7" }}>
                    <p className="badgeTextStyle">Smart Things</p>
                  </div>
                </div>
                <div className="overlay">
                  <div className="text">
                    <p className="pText">
                      Cities are getting smarter by the years. Many governments
                      around the globe are racing to infuse technology into
                      every aspect of its city’s operations ...
                    </p>
                    {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                  </div>
                </div>
              </div>
              <p className="titleArticleSuiv">What is a smart city?</p>
              <p className="dateArticle">4 Avril, 2018</p>
            </div>
            <div className="containerImg">
              <div className="imagewithtext">
                <img
                  style={{ paddingRight: "5px", paddingLeft: "5px" }}
                  src={image_A7}
                  alt=""
                  className="image"
                />
                <div className="bottom-left">
                  <div
                    className="newbadge"
                    style={{ background: "#1a54e7", marginLeft: "5px" }}
                  >
                    <p className="badgeTextStyle">Smart Things</p>
                  </div>
                </div>
                <div className="overlay">
                  <div className="text">
                    <p className="pText">
                      {" "}
                      Two decades ago, computers were pretty much the unique
                      devices that were connected to the internet. Nowadays,
                      that idea is no longer relevant...
                    </p>
                    {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                  </div>
                </div>
              </div>
              <p className="titleArticleSuiv">
                3 principal ways the IoT is transforming companies
              </p>
              <p className="dateArticle">3 Mars, 2018</p>
            </div>
            <div className="containerImg">
              <div className="imagewithtext">
                <img
                  style={{ paddingLeft: "5px" }}
                  src={image_A8}
                  alt=""
                  className="image"
                />
                <div className="bottom-left">
                  <div
                    className="newbadge"
                    style={{ background: "#1a54e7", marginLeft: "5px" }}
                  >
                    <p className="badgeTextStyle">Technologie</p>
                  </div>
                </div>
                <div className="overlay">
                  <div className="text">
                    <p className="pText">
                      {" "}
                      Do you remember 20 years ago when computers started to
                      invade our homes? Since then, technology hasn’t stop to
                      change each aspect of our lives...
                    </p>
                    {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                  </div>
                </div>
              </div>
              <p className="titleArticleSuiv">How IoT impacts society?</p>
              <p className="dateArticle">28 Novembre, 2017</p>
            </div>
          </div>

          {/*<div className="containerImg">
                            
                                <img style={{ paddingRight: "5px" }} src={image_A4} alt="" className="image" />
                                <div className="bottom-left"><div className="newbadge" style={{ background: "#1a54e7" }}><p className="badgeTextStyle">Smart Things</p></div></div>
                                <div className="overlay">
                                    <div className="text">
                                        <p className="pText">Data has value. Combined data has more value. Using that great amount of data to get “things” interconnected is far greater...</p>
                                        {/* <ReactSVG id="arrowposition" src={arrow} /> */}
          {/*} </div>
                                </div>
                            </div>
                            <p className="titleArticleSuiv">Why do you need internet of things IoT?</p>
                            <p className="dateArticle">01 october,2018</p>
        </div>*/}
          {/*<div className="containerImg">
                            <div className="imagewithtext">
                                <img style={{ paddingLeft: "5px", paddingRight: "5px" }} src={image_A5} alt="" className="image" />
                                <div className="bottom-left"><div className="newbadge" style={{ background: "#a9ce4e", marginLeft: "5px" }}><p className="badgeTextStyle">Entreprise</p></div></div>
                                <div className="overlay">
                                    <div className="text">
                                        <p className="pText">The term « Artificial Intelligence » or « AI » has lately been mentioned more often than you might think,
                                        following the launch of research centers specialized in AI...</p>
                                        {/* <ReactSVG id="arrowposition" src={arrow} /> */}
          {/* </div>
                                </div>
                            </div>
                            <p className="titleArticleSuiv">Artificial Intelligence: What about Chifco?</p>
                            <p className="dateArticle">26 Septembre, 2018</p>
                        </div>
                        <div className="containerImg">
                            <div className="imagewithtext">
                                <img style={{ paddingLeft: "5px" }} src={image_A10} alt="" className="image" />
                                <div className="bottom-left"><div className="newbadge" style={{ background: "#1a54e7", marginLeft: "5px" }}><p className="badgeTextStyle">Smart Things</p></div></div>
                                <div className="overlay">
                                    <div className="text">
                                        <p className="pText"> Have you noticed lately, that there has been a sudden trend of startups all around?
                                        No doubt, there are plenty of passionate, smart, innovative entrepreneurs ...</p>
                                        {/* <ReactSVG id="arrowposition" src={arrow} /> */}
          {/* </div>
                                </div>
                            </div>
                            <p className="titleArticleSuiv">4 advices to build a successful IoT Startup</p>
                            <p className="dateArticle">2 Mai, 2018</p>
                        </div>*/}
          {/*</div>

                    <div className="container-Smart-Projects">
                       {/* <div className="containerImg">
                            <div className="imagewithtext">
                                <img style={{ paddingRight: "5px" }} src={image_A6} alt="" className="image" />
                                <div className="bottom-left"><div className="newbadge" style={{ background: "#1a54e7" }}><p className="badgeTextStyle">Smart Things</p></div></div>
                                <div className="overlay">
                                    <div className="text">
                                        <p className="pText">Cities are getting smarter by the years.
                                        Many governments around the globe are racing to infuse technology into every aspect of its city’s operations ...</p>
                                        {/* <ReactSVG id="arrowposition" src={arrow} /> */}
          {/* </div>
                                </div>
                            </div>
                            <p className="titleArticleSuiv">What is a smart city?</p>
                            <p className="dateArticle">4 Avril, 2018</p>
                        </div>
                        <div className="containerImg">
                            <div className="imagewithtext">
                                <img style={{ paddingRight: "5px", paddingLeft: "5px" }} src={image_A7} alt="" className="image" />
                                <div className="bottom-left"><div className="newbadge" style={{ background: "#1a54e7", marginLeft: "5px" }}><p className="badgeTextStyle">Smart Things</p></div></div>
                                <div className="overlay">
                                    <div className="text">
                                        <p className="pText"> Two decades ago, computers were pretty much the unique devices that were connected to the internet.
                                        Nowadays, that idea is no longer relevant...</p>
                                        {/* <ReactSVG id="arrowposition" src={arrow} /> */}
          {/*</div>
                                </div>
                            </div>
                            <p className="titleArticleSuiv">3 principal ways the IoT is transforming companies</p>
                            <p className="dateArticle">3 Mars, 2018</p>
                        </div>
                        <div className="containerImg">
                            <div className="imagewithtext">
                                <img style={{ paddingLeft: "5px" }} src={image_A8} alt="" className="image" />
                                <div className="bottom-left"><div className="newbadge" style={{ background: "#1a54e7", marginLeft: "5px" }}><p className="badgeTextStyle">Technologie</p></div></div>
                                <div className="overlay">
                                    <div className="text">
                                        <p className="pText"> Do you remember 20 years ago when computers started to invade our homes?
                                        Since then, technology hasn’t stop to change each aspect of our lives...</p>
                                        {/* <ReactSVG id="arrowposition" src={arrow} /> */}
          {/*} </div>
                                </div>
                            </div>
                            <p className="titleArticleSuiv">How IoT impacts society?</p>
                            <p className="dateArticle">28 Novembre, 2017</p>
                        </div>
                                    </div>*/}

          {/* <div style={{ width: "100%", margin: "0 auto" ,backgroundColor: "red" }} id="slidBlogResp">
                        <SliderBlog />
                    </div> */}
        </div>

        <div style={{ background: "#eee" }}>
          <div className="containerBlog">
            <Slider ref={(c) => (this.slider = c)} {...settings1}>
              <div key={1}>
                <div className="imagewithtext">
                  <img
                    style={{ paddingRight: "2%" }}
                    src={image_A9}
                    alt=""
                    className="image"
                  />
                  <div className="bottom-left">
                    <div className="newbadge" style={{ background: "#1a54e7" }}>
                      <p className="badgeTextStyle">Smart Things</p>
                    </div>
                  </div>
                  <div className="overlay">
                    <div className="text">
                      <p className="pText">
                        Have you noticed that it has become tricky to keep pace
                        with fast changing facets of technology in your daily
                        life? The way people accessed and used the internet a
                        few years back is not the same anymore...
                      </p>
                      {/* <ReactSVG id="arrowposition" src={arrow} />  */}
                    </div>
                  </div>
                </div>
                <p className="titleArticleSuiv">
                  Internet of Things change gaming industry{" "}
                </p>
                <p className="dateArticle">29 october,2017</p>
              </div>

              <div key={2}>
                <div className="imagewithtext">
                  <img
                    style={{ paddingLeft: "2%" }}
                    src={image_A11}
                    alt=""
                    className="image"
                  />
                  <div className="bottom-left">
                    <div
                      className="newbadge"
                      id="imgA11"
                      style={{ background: "#ffd904" }}
                    >
                      <p className="badgeTextStyle">Innovation</p>
                    </div>
                  </div>
                  <div className="overlay">
                    <div className="text">
                      <p className="pText">
                        {" "}
                        Virtual reality is a computer technology which creates
                        an artificial environment by using headsets. It’s the
                        combination of physical spaces and multi-projected
                        environments that generate simulation of realistic
                        images and sounds...
                      </p>
                      {/* <ReactSVG id="arrowposition" src={arrow} />  */}
                    </div>
                  </div>
                </div>
                <p className="titleArticleSuiv">
                  Virtual reality and its impact on humanity
                </p>
                <p className="dateArticle">13 Août, 2017</p>
              </div>

              <div key={3}>
                <div className="imagewithtext">
                  <img
                    style={{ paddingRight: "2%" }}
                    src={image_A9}
                    alt=""
                    className="image"
                  />
                  <div className="bottom-left">
                    <div className="newbadge" style={{ background: "#a9ce4e" }}>
                      <p className="badgeTextStyle">Entreprise</p>
                    </div>
                  </div>
                  <div className="overlay">
                    <div className="text">
                      <p className="pText">
                        2018 has been a challenging journey, full of inspiring
                        achievements and moments of genuine hope for all of us.
                        We had enjoyable moments and hard ones. But in the end,
                        we rised and made it through 2018. One more year of
                        arduous missions and successful projects...
                      </p>
                      {/* <ReactSVG id="arrowposition" src={arrow} />  */}
                    </div>
                  </div>
                </div>
                <p className="titleArticleSuiv">
                  Internet of Things change gaming industry{" "}
                </p>
                <p className="dateArticle">01 october,2018</p>
              </div>

              <div key={4}>
                <div className="imagewithtext">
                  <img
                    style={{ paddingLeft: "2%" }}
                    src={image_A9}
                    alt=""
                    className="image"
                  />
                  <div className="bottom-left">
                    <div
                      className="newbadge"
                      style={{ background: "#a9ce4e", marginLeft: "9px" }}
                    >
                      <p className="badgeTextStyle">Entreprise</p>
                    </div>
                  </div>
                  <div className="overlay">
                    <div className="text">
                      <p className="pText">
                        2018 has been a challenging journey, full of inspiring
                        achievements and moments of genuine hope for all of us.
                        We had enjoyable moments and hard ones. But in the end,
                        we rised and made it through 2018. One more year of
                        arduous missions and successful projects...
                      </p>
                      {/* <ReactSVG id="arrowposition" src={arrow} /> */}
                    </div>
                  </div>
                </div>
                <p className="titleArticleSuiv">
                  Internet of Things change gaming industry{" "}
                </p>
                <p className="dateArticle">01 october,2018</p>
              </div>
            </Slider>
            {/* <div style={{ textAlign: "center", display: "flex", margin: "0 auto", width: "fit-content" }}>
                            <div id="arrowbutton" onClick={this.previous}>
                                <img id="imgarrow" src={arrowleft} alt="" />
                            </div>
                            <div className="flex-child">
                                <div><p>{this.state.activeSlide2}/11</p></div>
                            </div>
                            <div id="arrowbutton" onClick={this.next}>
                                <img id="imgarrow" src={arrowright} alt="" />
                            </div>
                        </div>  */}
          </div>
        </div>
        <MapAddresse />
        <NewsLetter />
        <Footer />
      </div>
    );
  }
}

Blogs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Blogs);



// WEBPACK FOOTER //
// ./src/pages/blog.js